import { ROUTES } from '@constants/routes';

/** Query param read by the flow editor to auto-select and load a script. */
export const FLOW_SCRIPT_PARAM = 'script';

/** Build the deep link that opens a script by name in the flow editor. */
export const buildFlowEditorUrl = (scriptName) =>
  `${ROUTES.flowAgentScriptEditor}?${FLOW_SCRIPT_PARAM}=${encodeURIComponent(scriptName)}`;

/**
 * Open the flow editor for `scriptName` in a new tab.
 * Returns `false` when the browser blocked the popup so the caller can offer a
 * manual fallback link.
 */
export const openAgentScriptInFlowEditor = (scriptName) => {
  const handle = window.open(buildFlowEditorUrl(scriptName), '_blank');
  return Boolean(handle);
};
